export default __webpack_public_path__ + "media/c6d608e561434e854981cea707cea37f.png";